import React from "react"
import PropTypes from "prop-types"

const Summary = props => {
  Summary.propTypes = {
    message: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  }

  return (
    <li className="p-4 flex-col flex-auto" data-status={props.status}>
      <span className="message flex flex-row flex-auto text-sm text-gray-700 items-center">
        {props.message}
      </span>
    </li>
  )
}

export { Summary }
